// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══ Profile Page ══════════════════════════════════════════════════════════ */

.prof-wrap {
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  min-height: calc(100vh - var(--topbar-h, 62px));
}

.prof-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 32px;
}

.prof-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5a3e8c, #7b4fd4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Cinzel', Georgia, serif;
  font-size: 26px;
  font-weight: 700;
  color: #f0c040;
  border: 2px solid rgba(240, 192, 64, 0.35);
  flex-shrink: 0;
}

.prof-header-info h1 {
  font-family: 'Cinzel', Georgia, serif;
  font-size: 20px;
  color: #f0c040;
  margin: 0 0 4px;
  font-weight: 700;
}

.prof-header-info p {
  font-size: 12px;
  color: rgba(210, 195, 250, 0.5);
  margin: 0;
}

/* ── Tabs ── */
.prof-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 28px;
}

.prof-tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: rgba(210, 195, 250, 0.5);
  font-size: 12px;
  font-weight: 700;
  font-family: 'Cinzel', Georgia, serif;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 10px 20px 11px;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: -1px;
}

.prof-tab:hover { color: rgba(210, 195, 250, 0.85); }
.prof-tab.active { color: #f0c040; border-bottom-color: #f0c040; }

/* ── Cards ── */
.prof-card {
  background: linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0.015));
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  padding: 24px;
  margin-bottom: 20px;
}

.prof-card-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  color: rgba(240, 192, 64, 0.6);
  text-transform: uppercase;
  margin-bottom: 18px;
  font-family: 'Cinzel', Georgia, serif;
}

/* ── Form fields ── */
.prof-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.prof-grid .full { grid-column: 1 / -1; }

.prof-field label {
  display: block;
  font-size: 11px;
  color: rgba(200, 180, 255, 0.55);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.prof-field input,
.prof-field textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  padding: 9px 12px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.prof-field input:focus,
.prof-field textarea:focus { border-color: rgba(240, 192, 64, 0.4); }
.prof-field input::placeholder,
.prof-field textarea::placeholder { color: rgba(255,255,255,0.2); }

/* ── MFA toggle ── */
.prof-mfa-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.prof-mfa-row:last-child { border-bottom: none; }

.prof-mfa-info { flex: 1 1; }
.prof-mfa-info strong { display: block; font-size: 13px; color: rgba(255,255,255,0.85); margin-bottom: 2px; }
.prof-mfa-info span { font-size: 11px; color: rgba(210,195,250,0.4); }

.prof-toggle {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.prof-toggle-knob {
  position: absolute;
  top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.2s;
}

/* ── Buttons ── */
.prof-btn {
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 22px;
  cursor: pointer;
  transition: all 0.15s;
}

.prof-btn-primary {
  background: linear-gradient(135deg, #5a3e8c, #7b4fd4);
  color: #fff;
}

.prof-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }
.prof-btn-primary:disabled { opacity: 0.5; cursor: default; transform: none; }

.prof-btn-secondary {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.12);
  color: rgba(210,195,250,0.7);
}

/* ── Messages ── */
.prof-success {
  background: rgba(64, 200, 100, 0.1);
  border: 1px solid rgba(64, 200, 100, 0.25);
  color: #50e080;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}

.prof-error {
  background: rgba(240, 60, 60, 0.1);
  border: 1px solid rgba(240, 60, 60, 0.25);
  color: #ff7070;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}

.prof-footer { display: flex; gap: 10px; justify-content: flex-end; margin-top: 16px; }

/* ── Verify email page ── */
.verify-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 130px);
  padding: 40px 20px;
}

.verify-card {
  background: linear-gradient(135deg, #0d0820, #150d2a);
  border: 1px solid rgba(240, 192, 64, 0.2);
  border-radius: 18px;
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.verify-icon { font-size: 56px; margin-bottom: 20px; }

.verify-title {
  font-family: 'Cinzel', Georgia, serif;
  font-size: 22px;
  color: #f0c040;
  margin-bottom: 12px;
  font-weight: 700;
}

.verify-text { font-size: 14px; color: rgba(210,195,250,0.7); line-height: 1.6; margin-bottom: 24px; }

@media (max-width: 600px) {
  .prof-wrap { padding: 24px 16px 40px; }
  .prof-grid { grid-template-columns: 1fr; }
  .prof-grid .full { grid-column: 1; }
  .verify-card { padding: 32px 20px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/profile.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,MAAM;EACN,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kBAAkB,gCAAgC,EAAE;AACpD,mBAAmB,cAAc,EAAE,4BAA4B,EAAE;;AAEjE,gBAAgB;AAChB;EACE,oFAAoF;EACpF,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;6BAC6B,qCAAqC,EAAE;AACpE;oCACoC,4BAA4B,EAAE;;AAElE,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kDAAkD;AACpD;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD,iBAAiB,SAAO,EAAE;AAC1B,wBAAwB,cAAc,EAAE,eAAe,EAAE,6BAA6B,EAAE,kBAAkB,EAAE;AAC5G,sBAAsB,eAAe,EAAE,4BAA4B,EAAE;;AAErE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA,0BAA0B,aAAa,EAAE,2BAA2B,EAAE;AACtE,6BAA6B,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;;AAE7E;EACE,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,eAAe,aAAa,EAAE,SAAS,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAEtF,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe,eAAe,EAAE,mBAAmB,EAAE;;AAErD;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAErG;EACE,aAAa,uBAAuB,EAAE;EACtC,aAAa,0BAA0B,EAAE;EACzC,mBAAmB,cAAc,EAAE;EACnC,eAAe,kBAAkB,EAAE;AACrC","sourcesContent":["/* ══ Profile Page ══════════════════════════════════════════════════════════ */\n\n.prof-wrap {\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 40px 24px 60px;\n  min-height: calc(100vh - var(--topbar-h, 62px));\n}\n\n.prof-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.prof-avatar {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #5a3e8c, #7b4fd4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Cinzel', Georgia, serif;\n  font-size: 26px;\n  font-weight: 700;\n  color: #f0c040;\n  border: 2px solid rgba(240, 192, 64, 0.35);\n  flex-shrink: 0;\n}\n\n.prof-header-info h1 {\n  font-family: 'Cinzel', Georgia, serif;\n  font-size: 20px;\n  color: #f0c040;\n  margin: 0 0 4px;\n  font-weight: 700;\n}\n\n.prof-header-info p {\n  font-size: 12px;\n  color: rgba(210, 195, 250, 0.5);\n  margin: 0;\n}\n\n/* ── Tabs ── */\n.prof-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  margin-bottom: 28px;\n}\n\n.prof-tab {\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: rgba(210, 195, 250, 0.5);\n  font-size: 12px;\n  font-weight: 700;\n  font-family: 'Cinzel', Georgia, serif;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  padding: 10px 20px 11px;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-bottom: -1px;\n}\n\n.prof-tab:hover { color: rgba(210, 195, 250, 0.85); }\n.prof-tab.active { color: #f0c040; border-bottom-color: #f0c040; }\n\n/* ── Cards ── */\n.prof-card {\n  background: linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0.015));\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 14px;\n  padding: 24px;\n  margin-bottom: 20px;\n}\n\n.prof-card-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  color: rgba(240, 192, 64, 0.6);\n  text-transform: uppercase;\n  margin-bottom: 18px;\n  font-family: 'Cinzel', Georgia, serif;\n}\n\n/* ── Form fields ── */\n.prof-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.prof-grid .full { grid-column: 1 / -1; }\n\n.prof-field label {\n  display: block;\n  font-size: 11px;\n  color: rgba(200, 180, 255, 0.55);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.prof-field input,\n.prof-field textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  padding: 9px 12px;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.prof-field input:focus,\n.prof-field textarea:focus { border-color: rgba(240, 192, 64, 0.4); }\n.prof-field input::placeholder,\n.prof-field textarea::placeholder { color: rgba(255,255,255,0.2); }\n\n/* ── MFA toggle ── */\n.prof-mfa-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.prof-mfa-row:last-child { border-bottom: none; }\n\n.prof-mfa-info { flex: 1; }\n.prof-mfa-info strong { display: block; font-size: 13px; color: rgba(255,255,255,0.85); margin-bottom: 2px; }\n.prof-mfa-info span { font-size: 11px; color: rgba(210,195,250,0.4); }\n\n.prof-toggle {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.prof-toggle-knob {\n  position: absolute;\n  top: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  transition: left 0.2s;\n}\n\n/* ── Buttons ── */\n.prof-btn {\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 22px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.prof-btn-primary {\n  background: linear-gradient(135deg, #5a3e8c, #7b4fd4);\n  color: #fff;\n}\n\n.prof-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }\n.prof-btn-primary:disabled { opacity: 0.5; cursor: default; transform: none; }\n\n.prof-btn-secondary {\n  background: rgba(255,255,255,0.06);\n  border: 1px solid rgba(255,255,255,0.12);\n  color: rgba(210,195,250,0.7);\n}\n\n/* ── Messages ── */\n.prof-success {\n  background: rgba(64, 200, 100, 0.1);\n  border: 1px solid rgba(64, 200, 100, 0.25);\n  color: #50e080;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n\n.prof-error {\n  background: rgba(240, 60, 60, 0.1);\n  border: 1px solid rgba(240, 60, 60, 0.25);\n  color: #ff7070;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n\n.prof-footer { display: flex; gap: 10px; justify-content: flex-end; margin-top: 16px; }\n\n/* ── Verify email page ── */\n.verify-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 130px);\n  padding: 40px 20px;\n}\n\n.verify-card {\n  background: linear-gradient(135deg, #0d0820, #150d2a);\n  border: 1px solid rgba(240, 192, 64, 0.2);\n  border-radius: 18px;\n  padding: 48px 40px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n}\n\n.verify-icon { font-size: 56px; margin-bottom: 20px; }\n\n.verify-title {\n  font-family: 'Cinzel', Georgia, serif;\n  font-size: 22px;\n  color: #f0c040;\n  margin-bottom: 12px;\n  font-weight: 700;\n}\n\n.verify-text { font-size: 14px; color: rgba(210,195,250,0.7); line-height: 1.6; margin-bottom: 24px; }\n\n@media (max-width: 600px) {\n  .prof-wrap { padding: 24px 16px 40px; }\n  .prof-grid { grid-template-columns: 1fr; }\n  .prof-grid .full { grid-column: 1; }\n  .verify-card { padding: 32px 20px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
